import { mapActions, mapState } from 'vuex'

export default {
  computed: {
    ...mapState('users', ['users', 'usersReady', 'pending']),
  },
  methods: {
    ...mapActions('users', ['getUsers']),
    ...mapActions('library', ['mfcProcessing']),
  },
  created() {
    if (!this.usersReady && !this.pending.polls) {
      this.getUsers().then(() => {
        this.mfcProcessing()
      })
    }
  },
}
